import { encodeFunctionData, getAddress } from "viem";
import { SYNDICATE_FACTORY_ABI } from "../abis.js";
import { getDeployment } from "../addresses.js";
import { usage } from "../errors.js";
const ZERO_VALUE = "0x0";
const SUBDOMAIN_RE = /^[a-z0-9-]{1,63}$/;
export function encodeCreateFund(args, chainId) {
    if (typeof args.metadataURI !== "string" || args.metadataURI.length === 0) {
        throw usage("`metadataURI` must be a non-empty string (e.g. ipfs://...)");
    }
    if (typeof args.name !== "string" || args.name.length === 0) {
        throw usage("`name` must be a non-empty string");
    }
    if (typeof args.symbol !== "string" || args.symbol.length === 0) {
        throw usage("`symbol` must be a non-empty string");
    }
    if (typeof args.openDeposits !== "boolean") {
        throw usage("`openDeposits` must be a boolean");
    }
    if (!SUBDOMAIN_RE.test(args.subdomain)) {
        throw usage("`subdomain` must match /^[a-z0-9-]{1,63}$/ (lowercase letters, digits, hyphens)");
    }
    const asset = getAddress(args.asset);
    const creatorAgentId = typeof args.creatorAgentId === "bigint"
        ? args.creatorAgentId
        : BigInt(args.creatorAgentId);
    if (creatorAgentId < 0n)
        throw usage("`creatorAgentId` must be non-negative");
    const factory = getDeployment(chainId).sherwood.factory;
    const data = encodeFunctionData({
        abi: SYNDICATE_FACTORY_ABI,
        functionName: "createSyndicate",
        args: [
            creatorAgentId,
            {
                metadataURI: args.metadataURI,
                asset,
                name: args.name,
                symbol: args.symbol,
                openDeposits: args.openDeposits,
                subdomain: args.subdomain,
            },
        ],
    });
    return {
        txs: [{ to: factory, data, value: ZERO_VALUE, chainId }],
        preconditions: [
        // Creator must own the ERC-8004 NFT for `creatorAgentId` and have
        // pre-staked the owner bond via guardianRegistry.prepareOwnerStake.
        // No on-chain check from the SDK side — agent verifies upstream.
        ],
        description: `Create fund "${args.subdomain}" with ${args.openDeposits ? "open" : "whitelisted"} deposits.`,
        note: "Caller must own the ERC-8004 NFT for `creatorAgentId` and must have called `guardianRegistry.prepareOwnerStake` first to bond the owner stake. The factory's `createSyndicate` deploys a vault proxy + binds the owner stake atomically.",
    };
}
